<template>
  <v-container class="container-view" fluid>
    <v-row class="d-flex align-center justify-center flex-wrap text-center">
      <h1 class="font-futura">
        {{ this.customer.name }}
      </h1>
    </v-row>
    <v-row class="d-flex align-center justify-center flex-wrap text-center">
      <div class="text-h6 font-weight-medium">
        <span class="font-egyptienne">
          Statut
          {{
            this.customer.status.number == "" ||
            this.customer.status.number < 0 ||
            this.customer.status.number == null
              ? "0"
              : this.customer.status.number
          }}
          -
        </span>
        <span class="color-point font-egyptienne">
          {{
            this.stats.totalPoints == 0 || this.stats.totalPoints < 0
              ? 0
              : Math.ceil(this.stats.totalPoints).toLocaleString("fr-FR")
          }}
          points restants
        </span>
      </div>
    </v-row>
    <v-row>
      <v-col cols="8">
        <v-card elevation="6" style="border-radius: 0px">
          <v-tabs
            v-model="tab"
            align-tabs="start"
            color="#FFB300"
            slider-color="white"
            bg-color="#535756"
          >
            <v-tab
              elevation="6"
              value="commands"
              class="text-none font-futura-subtitle"
            >
              {{ $t("my-last-commands") }}
            </v-tab>
            <v-tab
              elevation="6"
              value="cost"
              class="text-none font-futura-subtitle"
              >{{ $t("my-cost") }}</v-tab
            >
          </v-tabs>

          <v-tabs-window v-model="tab">
            <v-tabs-window-item value="commands">
              <v-card style="border-radius: 0px">
                <v-card-text>
                  <v-data-table
                    v-model:page="page"
                    show-expand
                    :items="commandes"
                    :headers="headers"
                    :items-per-page="itemsPerPage"
                    :no-data-text="$t('no-data')"
                    item-value="orderNumber"
                    v-model:expanded="expanded"
                    class="font-humanist"
                  >
                    <template v-slot:top>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-select
                            clearable
                            chips
                            density="compact"
                            label="Filtre sur l'année"
                            variant="outlined"
                            hide-details
                            @update:modelValue="
                              selectedYearOrSearchFieldUpdated($event, 'YEAR')
                            "
                            :model-value="selectedYear"
                            :items="
                              Array.from(
                                { length: new Date().getFullYear() - 2023 + 1 },
                                (_, i) => 2023 + i,
                              )
                            "
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          class="d-flex align-center"
                          sm="8"
                          md="8"
                        >
                          <v-text-field
                            v-model="search"
                            density="compact"
                            :label="$t('search')"
                            class="pl-2"
                            :prepend-inner-icon="mdiMagnify"
                            variant="outlined"
                            @update:modelValue="debouncedSearchUpdate"
                            flat
                            hide-details
                            single-line
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </template>

                    <template v-slot:item.total="{ item }">
                      {{
                        Number(item.total.replace(",", ".")).toLocaleString(
                          "fr-FR",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )
                      }}
                      <span style="font-size: 1.8em">€</span>
                    </template>

                    <!-- eslint-disable -->
                    <template
                      v-slot:item.data-table-expand="{
                        internalItem,
                        isExpanded,
                        toggleExpand,
                      }"
                    >
                      <v-icon
                        :icon="
                          isExpanded(internalItem)
                            ? mdiChevronUp
                            : mdiChevronDown
                        "
                        data-cy="expand-order-btn"
                        @click="toggleExpand(internalItem)"
                      >
                      </v-icon>
                    </template>
                    <template v-slot:expanded-row="{ columns, item }">
                      <tr>
                        <td :colspan="columns.length">
                          <v-sheet elevation="9">
                            <v-data-table
                              show-expand
                              :items="item.orders"
                              :headers="headersOrders"
                              item-value="invoiceNumber"
                              density="compact"
                              hide-default-footer
                              hide-default-header
                            >
                              <!-- eslint-disable-next-line -->
                              <template
                                v-slot:item="{
                                  item,
                                  columns,
                                  internalItem,
                                  toggleExpand,
                                  isExpanded,
                                }"
                              >
                                <tr>
                                  <!-- eslint-disable-next-line -->
                                  <td v-for="column in columns">
                                    <v-btn
                                      rounded="0"
                                      v-if="column.key === 'data-table-expand'"
                                      :icon="
                                        isExpanded(internalItem)
                                          ? mdiArrowUpDropCircleOutline
                                          : mdiArrowDownDropCircleOutline
                                      "
                                      variant="plain"
                                      @click="toggleExpand(internalItem)"
                                      data-cy="expand-invoice-btn"
                                    ></v-btn>
                                    <span v-else>{{
                                      $t("invoice-number") +
                                      " : " +
                                      item[column.key]
                                    }}</span>
                                  </td>
                                </tr>
                              </template>
                              <template v-slot:expanded-row="{ columns, item }">
                                <tr>
                                  <td :colspan="columns.length">
                                    <v-sheet elevation="9" class="mt-3 mb-3">
                                      <v-table>
                                        <thead>
                                          <tr class="grey lighten-4">
                                            <th>{{ $t("reference") }}</th>
                                            <th>{{ $t("description") }}</th>
                                            <th>{{ $t("price") }}</th>
                                            <th>{{ $t("quantity") }}</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            v-for="(
                                              product, index
                                            ) in item.products"
                                            :key="index"
                                            class="grey lighten-4"
                                          >
                                            <td>
                                              {{ product.reference }}
                                            </td>
                                            <td>
                                              {{ product.description }}
                                            </td>
                                            <td>
                                              {{
                                                Number(
                                                  product.salesAmount.replace(
                                                    ",",
                                                    ".",
                                                  ),
                                                ).toLocaleString("fr-FR", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })
                                              }}
                                            </td>
                                            <td>
                                              {{ product.quantity }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </v-table>
                                    </v-sheet>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-sheet>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:bottom>
                      <div class="text-center pt-2">
                        <v-pagination
                          v-model="page"
                          :length="pageCount"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tabs-window-item>

            <v-tabs-window-item value="cost">
              <v-card style="border-radius: 0px">
                <v-card-text>
                  <v-data-table
                    :items="stats.cost"
                    :headers="headersCost"
                    hide-default-footer
                    :no-data-text="$t('no-data')"
                  >
                    <template v-slot:item.totalBillingFees="{ item }">
                      {{ parseFloat(item.totalBillingFees).toLocaleString() }} €
                    </template>

                    <template v-slot:item.totalDeliveryCost="{ item }">
                      {{ parseFloat(item.totalDeliveryCost).toLocaleString() }}
                      €
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card>
      </v-col>
      <v-col cols="4" class="pl-0">
        <div>
          <v-btn
            class="ma-2 text-white font-futura-button"
            color="#395d5b"
            data-cy="export-excel"
            @click="exportExcel"
            rounded="0"
          >
            Export Excel
            <v-icon :icon="mdiFileExcel" end size="x-large"></v-icon>
          </v-btn>
        </div>
        <div id="chart">
          <apexchart
            class="apex-chart"
            type="donut"
            width="500"
            :options="chartOptions"
            :series="stats.totals"
          ></apexchart>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import points from "@/mixins/points";
import {
  mdiArrowUpDropCircleOutline,
  mdiArrowDownDropCircleOutline,
  mdiFileExcel,
  mdiChevronUp,
  mdiChevronDown,
  mdiMagnify,
} from "@mdi/js";

export default {
  name: "StrykerCommands",
  mixins: [points],
  data() {
    return {
      tab: null,
      mdiArrowDownDropCircleOutline,
      mdiArrowUpDropCircleOutline,
      mdiFileExcel,
      mdiChevronUp,
      mdiChevronDown,
      mdiMagnify,
      page: 1,
      expanded: [],
      selectedYear: null,
      search: null,
      itemsPerPage: 10,
      debouncedSearchUpdate: null,
      headers: [
        {
          title: this.$t("command-date"),
          align: "start",
          sortable: false,
          key: "date",
        },
        {
          title: this.$t("order-number"),
          align: "start",
          key: "orderNumber",
        },
        { title: this.$t("total"), align: "start", key: "total" },
      ],
      headersCost: [
        {
          title: this.$t("year"),
          align: "start",
          sortable: false,
          key: "year",
        },
        {
          title: this.$t("total-billing-fees"),
          align: "start",
          key: "totalBillingFees",
        },
        {
          title: this.$t("total-delivery-cost"),
          align: "start",
          key: "totalDeliveryCost",
        },
      ],
      headersOrders: [
        {
          title: this.$t("invoice-number"),
          align: "start",
          key: "invoiceNumber",
        },
      ],
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
        },
        labels: ["NON ALLOCATED"],
        colors: [
          "#FFB300",
          "#B66A00",
          "#80BDB8",
          "#0092E2",
          "#22605B",
          "#397D7D",
          "#005C87",
          "#DDD8D9",
          "#858482",
          "#3761C2",
          "#532571",
          "#B6743A",
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
        legend: {
          position: "right",
          offsetY: 0,
        },
      },
    };
  },
  watch: {
    stats: {
      handler(newStats) {
        this.chartOptions.labels = newStats.names;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      customer: (state) => state.users.selectedCustomer,
      stats: (state) => state.statsCustomer.statsCustomer,
    }),
    pageCount() {
      return Math.ceil(this.commandes.length / this.itemsPerPage);
    },
    commandes: {
      get() {
        return this.$store.state.strykerCommands.items;
      },
    },
  },
  created() {
    this.debouncedSearchUpdate = this.debounce(this.searchUpdate, 300); // 300ms de délai
  },
  methods: {
    selectedYearOrSearchFieldUpdated($event, type) {
      if (type === "YEAR") {
        this.selectedYear = $event;
      } else if (type === "SEARCH") {
        this.search = $event;
      }
      const query = {
        customerId: this.customer.id,
        year: this.selectedYear,
        search: this.search,
      };
      this.$store.dispatch(
        "strykerCommands/fetchCustomerCommandsWithQuery",
        query,
      );
    },
    debounce(func, wait) {
      let timeout;
      return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },
    searchUpdate(value) {
      this.selectedYearOrSearchFieldUpdated(value, "SEARCH");
    },
    exportExcel() {
      this.$store.commit("setOverlay", true);
      const data = {
        type: "strykercommands",
        customerId: this.customer.id,
      };

      if (
        this.selectedYear !== null ||
        (this.search !== null && this.search !== "")
      ) {
        data.year = this.selectedYear;
        data.search = this.search;
      }
      this.$store
        .dispatch("exportExcelWithQuery", data)
        .then((response) => {
          this.$store.commit("setOverlay", false);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // Create a link element
          const link = document.createElement("a");
          // Set the download attribute with the desired file name
          link.download = "CommandesStryker.xlsx";

          // Create a URL for the Blob and set it as the link's href
          link.href = window.URL.createObjectURL(blob);

          // Append the link to the document
          document.body.appendChild(link);

          // Trigger a click on the link to start the download
          link.click();

          // Remove the link from the document
          document.body.removeChild(link);
        })
        .catch((error) => {
          if (error.status == 400) {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: "Action non autorisée.",
              color: "error",
            });
          } else {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.export-excel"),
              color: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.apex-chart {
  padding-top: 50px;
}
</style>
